import generateRefundCodes from './generateRefundCodes';
import getConnectorStatus from './getConnectorStatus';
import { getCredentialsQuery } from './getCredentialsQuery';
import getSellerExportBySellerId from './getSellerExportBySellerId';
import { setCredentialsCommand } from './setCredentialsCommand';
import setRefund from './setRefund';

export const MarketplaceService = {
  setCredentialsCommand,
  getCredentialsQuery,
  generateRefundCodes,
  getConnectorStatus,
  getSellerExportBySellerId,
  setRefund,
};
